export default function tenantsGetCurrentLayout() {
  return digg(window, "currentLayout")
}
